import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  Box, 
  Typography, 
  Button,
  Paper,
  Alert,
} from '@mui/material';
import { ArrowBack, People } from '@mui/icons-material';

const CustomerDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/customers')}
          variant="outlined"
        >
          Back to Customers
        </Button>
        <Box>
          <Typography variant="h4" gutterBottom>
            Customer Details
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Customer ID: {id}
          </Typography>
        </Box>
      </Box>

      <Paper sx={{ p: 3 }}>
        <Alert severity="info" sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            🚧 Page Under Development
          </Typography>
          This page will include:
          <ul>
            <li>Complete customer contact information</li>
            <li>Property details and specifications</li>
            <li>Project history and timeline</li>
            <li>Communication log and notes</li>
            <li>Document attachments and photos</li>
            <li>Lead source and referral tracking</li>
          </ul>
        </Alert>
        
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <People sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">
            Customer detail view coming soon
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Customer ID: {id}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default CustomerDetailPage;
